import * as React from "react"
import TemperatureIcon from "../../atoms/icons/TemperatureIcon"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import { SECTION_OVERVIEW_TEMPERATURES } from "../../../utils/pages"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import { TEMPERATURES_FLOAT_DECIMAL_COUNT } from "../../constants"
import ButtonRow from "../../molecules/card/ButtonRow"
import MultiStateButton from "../../atoms/buttons/MultiStateButton"

type TemperatureUnit = "°C" | "°F"

const TemperaturesCard: React.FunctionComponent = () => {
  const { metrics } = useEdgeApi()
  const [unit, setUnit] = React.useState<TemperatureUnit>("°C")

  const celsiusToFahrenheit = (celsius: number) => (celsius * 9) / 5 + 32

  const displayTemperature = (celsius?: number) => {
    if (celsius === undefined) return undefined
    if (unit === "°C") {
      return `${celsius.toFixed(TEMPERATURES_FLOAT_DECIMAL_COUNT)}°C`
    }
    return `${celsiusToFahrenheit(celsius).toFixed(TEMPERATURES_FLOAT_DECIMAL_COUNT)}°F`
  }

  return (
    <SettingsOverviewCard title={SECTION_OVERVIEW_TEMPERATURES.name} icon={<TemperatureIcon />}>
      <ButtonRow
        label="Unit"
        button={
          <MultiStateButton
            id="temperature-unit"
            options={["°C", "°F"] as TemperatureUnit[]}
            value={unit}
            onClick={setUnit}
          />
        }
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="Alpha motor"
        value={displayTemperature(metrics.useMotorDiagnosticsAlphaWindingTemp())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="Beta motor"
        value={displayTemperature(metrics.useMotorDiagnosticsBetaWindingTemp())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="BUC HPA1"
        value={displayTemperature(metrics.useBucTelemetriesTempSensor1())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="BUC HPA2"
        value={displayTemperature(metrics.useBucTelemetriesTempSensor2())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="BUC Sensor Ctrl"
        value={displayTemperature(metrics.useBucTelemetriesTempSensorCtrl())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="LNB Sensor"
        value={displayTemperature(metrics.useLnbTelemetriesTempSensor1())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="LNB Sensor Ctrl"
        value={displayTemperature(metrics.useLnbTelemetriesTempSensorCtrl())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="Parental board"
        value={displayTemperature(metrics.useBoardTemperaturesPbTemperature())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="Power board"
        value={displayTemperature(metrics.useBoardTemperaturesPwbTemperature())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="Transceiver board"
        value={displayTemperature(metrics.useBoardTemperaturesTbbTemperature())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="CPU"
        value={displayTemperature(metrics.useBoardTemperaturesCpuTemperature())}
      />
      <ReadOnlyTextField
        placeholder="-- -"
        label="SoC"
        value={displayTemperature(metrics.useBoardTemperaturesSocTemperature())}
      />
    </SettingsOverviewCard>
  )
}

export default TemperaturesCard
